import { useQuery } from 'react-query'
import { fetchUser } from '../../api/fetchUser'
import { getUserQueryKey } from '../query-keys'

export const useUser = ({ userId }: { userId: string }) => {
  return useQuery(getUserQueryKey({ userId }), () => fetchUser({ userId }), {
    enabled: !!userId,
  })
}
